import type { IconSvgObject } from './types';

const ListIndentIncreaseIcon: IconSvgObject = [
  ["path", { d: "M11 12H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 19H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 5H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3.00006 16C3.00006 16 7.00002 13.054 7.00003 12C7.00004 10.9459 3.00003 8 3.00003 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ListIndentIncreaseIcon;
